import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import { FigureId } from "../const";
import "./index.scss";

interface IProps {
    showVideoId: number;
    onClose: () => void;
}

interface IState {
    loading: boolean;
}

const videoMap = {
    [FigureId.XX]: "https://static.jjbisai.com/website/other/hxzyy/xxe.ts",
    [FigureId.ZZ]: "https://static.jjbisai.com/website/other/hxzyy/zzv.ts",
    [FigureId.NQ]: "https://static.jjbisai.com/website/other/hxzyy/nq.ts",
    // [FigureId.XX]: "https://static.jjbisai.com/website/videos/hxzyy/xxe.mp4",
    // [FigureId.ZZ]: "https://static.jjbisai.com/website/videos/hxzyy/zz.mp4",
    // [FigureId.NQ]: "https://static.jjbisai.com/website/videos/hxzyy/nq.mp4",
};

const picMap = {
    [FigureId.XX]: "https://static.jjbisai.com/website/imgs/hxzyy/modal/pic-xx.png",
    [FigureId.ZZ]: "https://static.jjbisai.com/website/imgs/hxzyy/modal/pic-zz.png",
    [FigureId.NQ]: "https://static.jjbisai.com/website/imgs/hxzyy/modal/pci-nq.png",
    // [FigureId.XX]: "https://static.jjbisai.com/website/videos/hxzyy/xxe.mp4",
    // [FigureId.ZZ]: "https://static.jjbisai.com/website/videos/hxzyy/zz.mp4",
    // [FigureId.NQ]: "https://static.jjbisai.com/website/videos/hxzyy/nq.mp4",
};

// 人物弹窗
class FigureModal extends BaseComponent<IProps, IState> {
    private player: any;

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: true,
        };
        this.player = null;
    }

    componentDidMount() {
        this.initVideo();
    }

    componentWillUnmount() {
        this.player.stop();
    }

    // 初始化视频
    initVideo = () => {
        const { showVideoId } = this.props;
        const url = videoMap[showVideoId] || "";
        // @ts-ignore
        this.player = new JSMpeg.Player(url, {
            canvas: document.getElementById("videos"),
            loop: false,
            autoplay: true,
            throttled: false,
            progressive: false,
            audio: true,
            // onEnded: this.props.handleEndAni,
            onSourceEstablished: () => {
                this.setState({
                    loading: false,
                });
            },
        });
        this.player.audioOut.unlock();
        this.player.play();
    };

    render() {
        const { showVideoId, onClose } = this.props;
        const { loading } = this.state;
        const picUrl = picMap[showVideoId] || "";

        return (
            <div className="figure-modal">
                <div className="figure-video">
                    <div className="btn-close" onClick={onClose}></div>
                    {loading ? <img className="pic-figure" src={picUrl} alt="" /> : null}
                    <canvas id="videos" className={loading ? "videos-ani hidden" : "videos-ani"} width={"100%"} height={"100%"}></canvas>
                    {loading ? <div className="video-loading"></div> : null}
                    {/* <video
                        src={url}
                        // controls
                        autoPlay={true}
                        x5-video-player-fullscreen="true"
                        x5-playsinline="true"
                        playsInline
                        webkit-playsinline="true"
                    ></video> */}
                </div>
            </div>
        );
    }
}

export default FigureModal;
